'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Key.es.js";
const o = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: e }));
o.displayName = "KeyIcon";
const n = o;
export {
  n as Key,
  o as KeyIcon
};
